var QueryCaseTurnRecord = function () { return import('~/pages/synthesize-query-manage/query-case-turn-record.vue'); };
var QueryCaseOutRecord = function () { return import('~/pages/synthesize-query-manage/query-case-out-record.vue'); };
var InBoundQuery = function () { return import('~/pages/synthesize-query-manage/inbound-query.vue'); };
var MessageSendRecordQuery = function () { return import('~/pages/synthesize-query-manage/message-send-record-query.vue'); };
var RepaymentRecordQuery = function () { return import('~/pages/synthesize-query-manage/repayment-record-query.vue'); };
var RecordQuery = function () { return import('~/pages/synthesize-query-manage/record-query.vue'); };
var StrategyAllotRecordQuery = function () { return import('~/pages/synthesize-query-manage/strategy-allot-record-query.vue'); };
var CaseInfoQuery = function () { return import('~/pages/synthesize-query-manage/case-info-query.vue'); };
var CaseReturnQuery = function () { return import('~/pages/synthesize-query-manage/case-return-query.vue'); };
export default [
    {
        path: '/synthesize-query-manage/query-case-turn-record',
        name: 'query-case-turn-record',
        title: '',
        component: QueryCaseTurnRecord,
    },
    {
        path: '/synthesize-query-manage/query-case-out-record',
        name: 'query-case-out-record',
        title: '委外记录查询',
        component: QueryCaseOutRecord,
    },
    {
        path: '/synthesize-query-manage/inbound-query',
        name: 'inbound-query',
        title: '呼入案件查询',
        component: InBoundQuery,
    },
    {
        path: '/synthesize-query-manage/message-send-record-query',
        name: 'message-send-record-query',
        title: '短信发送查询',
        component: MessageSendRecordQuery,
    },
    {
        path: '/synthesize-query-manage/repayment-record-query',
        name: 'repayment-record-query',
        title: '实施还款查询',
        component: RepaymentRecordQuery,
    }, {
        path: '/synthesize-query-manage/record-query',
        name: 'record-query',
        title: '还款查询',
        component: RecordQuery,
    },
    {
        path: '/synthesize-query-manage/strategy-allot-record-query',
        name: 'strategy-allot-record-query',
        title: '策略分案查询',
        component: StrategyAllotRecordQuery,
    },
    {
        path: '/synthesize-query-manage/case-info-query',
        name: 'case-info-query',
        title: '案件查询',
        component: CaseInfoQuery,
    },
    {
        path: '/synthesize-query-manage/case-return-query',
        name: 'case-return-query',
        title: '案件流转查询',
        component: CaseReturnQuery,
    }
];
